<template>
    <div class="py-4 shape_block">
        <h4 class="mb-4 text-center pb-2 font-active">Shop By Shape</h4>
        <p class="text-center mb-4 pb-4">Diamonds come in various shapes. Take a detailed look at all the popular shapes
            most commonly used to create lab diamond engagement rings.</p>

        <div class="shape_main for_desktop">
            <div class="shape_flex">
                <div class="slide_box">
                    <NuxtLink :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'round-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/round.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/round.jpg" alt="Round Cut Diamonds">
                        </picture>
                        <h5 class="font-active">round cut</h5>
                        <p>Brilliant round cuts have the most brilliance. They have perfect symmetry and disperse
                            maximum light, making them the most desired diamond shape of all.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>

                <div class="slide_box">
                    <NuxtLink :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'oval-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/oval.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/oval.jpg" alt="Oval Cut Diamonds">
                        </picture>
                        <h5 class="font-active">oval cut</h5>
                        <p>Oval cuts are elongated variants of brilliant round cuts. They capture the same sparkle as
                            round cuts and make an elegant yet out-of-the-box cut that gives the wearer's finger more
                            length. Currently, they are the most trending shape of the year.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>

                <div class="slide_box">
                    <NuxtLink :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'pear-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/pear.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/pear.jpg" alt="Pear Cut Diamonds">
                        </picture>
                        <h5 class="font-active">pear cut</h5>
                        <p>Pear cuts, also known as teardrops, are hybrids of the oval and marquise cuts. They are
                            perfect for vintage-inspired rings but also pair well with modern-day designs. Choosing a
                            bezel or half-v ring setting gives maximum protection to your pear diamond.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>

                <div class="slide_box">
                    <NuxtLink
                        :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'cushion-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/cushion.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/cushion.jpg" alt="Cushion Cut Diamonds">
                        </picture>
                        <h5 class="font-active">cushion cut</h5>
                        <p>Cushion cuts have exquisite square cut diamonds with rounded corners. They exude an old-world
                            charm, have exceptional sparkle, and match perfectly with vintage designs.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>

                <div class="slide_box">
                    <NuxtLink
                        :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'princess-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/princess.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/princess.jpg" alt="Princess Cut Diamonds">
                        </picture>
                        <h5 class="font-active">princess cut</h5>
                        <p>Princess cuts have modern, geometrically designed diamonds that produce abundant sparkle.
                            They are less expensive than brilliant round cuts and should be paired with channel or four
                            prong settings for protection.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>

                <div class="slide_box">
                    <NuxtLink
                        :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'radiant-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/radiant.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/radiant.jpg" alt="Radiant Cut Diamonds">
                        </picture>
                        <h5 class="font-active">radiant cut</h5>
                        <p>Radiant cuts are similar to emerald cuts. The only difference is that radiant cut diamonds
                            have unique, deeper-cut facets that give the diamond more sparkle.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>

                <div class="slide_box">
                    <NuxtLink :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'heart-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/heart.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/heart.jpg" alt="Heart Cut Diamonds">
                        </picture>
                        <h5 class="font-active">heart cut</h5>
                        <p>Heart cuts are feminine, heart-shaped diamonds that are a modified version of the brilliant
                            round cut. This diamond shape is an absolute symbol of love and has exceptional symmetry and
                            brilliance, giving it a spectacular shine.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>

                <div class="slide_box">
                    <NuxtLink
                        :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'emerald-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/emerald.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/emerald.jpg" alt="Emerald Cut Diamonds">
                        </picture>
                        <h5 class="font-active">emerald cut</h5>
                        <p>Emerald cuts are rectangular step cut gems reminiscent of the 1920s and 1930s Art Deco Era.
                            While these may not have an outstanding sparkle, this shape captures the gem's clarity and
                            light in an enthralling fashion.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>

                <div class="slide_box">
                    <NuxtLink
                        :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'marquise-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/marquise.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/marquise.jpg" alt="Marquise Cut Diamonds">
                        </picture>
                        <h5 class="font-active">marquise cut</h5>
                        <p>Marquise cut diamonds have a unique silhouette with curved sides and pointed ends, making
                            them an epitome of royalty. The cut gives the gems an extraordinary size while providing an
                            elongated look to the wearer's finger.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>

                <div class="slide_box">
                    <NuxtLink
                        :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'asscher-rings' } })"
                        class="">
                        <picture>
                            <source width="336" height="330" type="image/webp"
                                srcset="~/assets/landing/engagement/shape/asscher.webp">
                            <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                src="~/assets/landing/engagement/shape/asscher.jpg" alt="Asscher Cut Diamonds">
                        </picture>
                        <h5 class="font-active">asscher cut</h5>
                        <p>Asscher cut diamonds come in square with layered facets of unique symmetry and geometric
                            designs. This cut displays beautiful radiance and sparkle and is an ode to the fashion
                            statement of Art Deco period.</p>
                        <div class="cta_btn">Shop </div>
                    </NuxtLink>
                </div>
            </div>
        </div>
        <div class="for_mobile">
            <swiper 
                :loop="true" 
                :autoplay="{
                    delay: 2500,
                    disableOnInteraction: false,
                }" 
                :modules="[SwiperAutoplay]" 
                :breakpoints="{
                    0: {
                        slidesPerView: 1.5,
                        slidesPerGroup: 1,
                        spaceBetween: 5,
                        centeredSlides: true,
                    },
                }" 
                class="myswiper">
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'round-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/round.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/round.jpg" alt="Round Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/round.webp" alt="Round Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active"> round cut</h5>
                                <p>Brilliant round cuts have the most brilliance. Brilliant round cuts have perfect
                                    symmetry and disperse maximum light, making it the most desired diamond shape of
                                    all.</p>
                                <div class="cta_btn">shop</div>
                            </div>
                        </NuxtLink>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'oval-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/oval.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/oval.jpg" alt="Oval Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/oval.webp" alt="Oval Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active">oval cut</h5>
                                <p>Oval cuts are elongated variants of brilliant round cuts. Oval cuts capture the same
                                    sparkle as round cuts and make an elegant yet out-of-the-box cut that gives the
                                    wearer's finger more length. They are also currently the most trending shape of the
                                    year.</p>
                                <div class="cta_btn">shop</div>
                            </div>

                        </NuxtLink>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'pear-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/pear.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/pear.jpg" alt="Pear Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/pear.webp" alt="Pear Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active">pear cut</h5>
                                <p>Pear cuts, also known as teardrops, are hybrids of the oval and marquise cut. They
                                    are perfect for vintage inspired rings but also pair well with modern-day designs.
                                    Choosing a bezel or half-v ring setting gives maximum protection to your pear
                                    diamond.</p>
                                <div class="cta_btn">shop</div>
                            </div>
                        </NuxtLink>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'cushion-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/cushion.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/cushion.jpg" alt="Cushion Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/cushion.webp" alt="Cushion Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active">cushion cut</h5>
                                <p>Cushion cuts have exquisite square cut diamonds with rounded corners. They exude an
                                    old-world charm, have an exceptional sparkle, and match perfectly with vintage
                                    designs.</p>
                                <div class="cta_btn">shop</div>
                            </div>
                        </NuxtLink>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'princess-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/princess.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/princess.jpg" alt="Princess Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/princess.webp" alt="Princess Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active">princess cut</h5>
                                <p>Princess cuts have modern geometrically designed diamonds that produce abundant
                                    sparkle. They are less expensive than brilliant round cuts and should be paired with
                                    channel or four prong settings for protection.</p>
                                <div class="cta_btn">shop</div>
                            </div>
                        </NuxtLink>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'radiant-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/radiant.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/radiant.jpg" alt="Radiant Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/radiant.webp" alt="Radiant Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active">radiant cut</h5>
                                <p>Radiant cuts are similar to emerald cuts. The only difference is that radiant cut
                                    diamonds have unique deeper-cut facets that give the diamond more sparkle.</p>
                                <div class="cta_btn">shop</div>
                            </div>

                        </NuxtLink>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'heart-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/heart.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/heart.jpg" alt="Heart Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/heart.webp" alt="Heart Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active">heart cut</h5>
                                <p>Heart cuts are feminine heart-shaped diamonds that are a modified version of the
                                    brilliant round cut. This diamond shape is an absolute symbol of love and has
                                    exceptional symmetry and brilliance, giving it a spectacular shine.</p>
                                <div class="cta_btn">shop</div>
                            </div>
                        </NuxtLink>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'emerald-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/emerald.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/emerald.jpg" alt="Emerald Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/emerald.webp" alt="Emerald Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active">emerald cut</h5>
                                <p>Emerald cuts are rectangular step cut gems reminiscent of the 1920s and 1930s Art
                                    Deco Era. While these may not have an outstanding sparkle, this shape captures the
                                    gem's clarity and light in an enthralling fashion.</p>
                                <div class="cta_btn">shop</div>
                            </div>
                        </NuxtLink>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'marquise-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/marquise.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/marquise.jpg" alt="Marquise Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/marquise.webp" alt="Marquise Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active">marquise cut</h5>
                                <p>Marquise cut diamonds have a unique silhouette with curved sides and pointed ends,
                                    making them the epitome of royalty. The cut gives the gems an extraordinary size
                                    while providing an elongated look to the wearer's finger.</p>
                                <div class="cta_btn">shop</div>
                            </div>
                        </NuxtLink>
                    </div>
                </swiper-slide>
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink
                            :to="localePath({ name: 'cyo-diamond-list-ring', params: { start_with: 'asscher-rings' } })"
                            class="">
                            <picture>
                                <source width="336" height="330" type="image/webp"
                                    srcset="~/assets/landing/engagement/shape/asscher.webp">
                                <img class="radious_eight" loading="lazy" width="336" height="330" type="image/jpeg"
                                    src="~/assets/landing/engagement/shape/asscher.jpg" alt="Asscher Cut Diamonds">
                            </picture>
                            <!-- <b-img loading="lazy" width="336" height="330" src="~/assets/landing/engagement/shape/asscher.webp" alt="Asscher Cut Diamonds"></b-img> -->
                            <div class="wrap_content">
                                <h5 class="font-active">asscher cut</h5>
                                <p>Asscher cut diamonds come in square with layered facets of unique symmetry and
                                    geometric designs. This cut displays beautiful radiance & sparkle and is an ode to
                                    the fashion statement of Art Deco period.</p>
                                <div class="cta_btn">shop</div>
                            </div>
                        </NuxtLink>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>


<script setup>
const props = defineProps({
    locale: String
});

const localePath = useLocalePath()


</script>

<style scoped>
:global(.myswiper .swiper-slide) {
    height: auto !important;
}

.shape_block {
    width: 93%;
    margin: 0 auto;
}

h4 {
    font-size: 30px;
}

p {
    font-weight: 500;
    color: #6a6161;
}

.shape_flex {
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
    flex-wrap: wrap;
}

.slide_box {
    position: relative;
    cursor: pointer;
    width: 19%;
    margin-bottom: 3%;
}

.slide_box a {
    color: #000;
}

h5 {
    font-size: 24px;
    text-transform: capitalize;
    padding: 8% 0 2%;
}

.cta_btn {
    border: 1px solid #000;
    text-align: center;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: 600;
    padding: 7px;
    margin-top: 9%;
    border-radius: 4px;
}

.slide_box p {
    min-height: 150px;
}

@media(max-width: 1600px) {
    .slide_box p {
        min-height: 195px;
    }
}

@media(max-width: 1350px) {
    .slide_box p {
        min-height: 220px;
        font-size: 15px;
    }

    h5 {
        font-size: 20px;
    }

}

@media(max-width: 1150px) {
    .slide_box p {
        font-size: 16px;
    }

    .shape_flex {
        justify-content: center;
    }

    .slide_box {
        width: 23%;
        margin: 8px 8px 24px 8px;
    }

}

@media(max-width: 992px) {
    .slide_box {
        width: 32.7%;
        margin: 0 0 20px 0;
    }

    .shape_flex {
        justify-content: space-between;
    }

    .slide_box p {
        min-height: 200px;
    }
}

@media(max-width: 767px) {

    .for_mobile {
        display: none;
    }

    h4 {
        font-size: 24px;
    }

    .slide_box {
        width: 100%;
        margin: 0;
        text-align: center;
        padding: 0 3%;
    }




}

@media(max-width: 512px) {

    /* .slick-slide.slick-active.slick-center.slick-current .slide_box h5,
        .slick-slide.slick-active.slick-center.slick-current .slide_box p,
        .slick-slide.slick-active.slick-center.slick-current .slide_box .cta_btn{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .shape_block{
            width: 100%;
            margin: 0 auto;
        } */

    .swiper-slide .wrap_content {
        display: none;
    }

    .swiper-slide-active .wrap_content {
        display: block;
    }
}
</style>